import clsx from 'clsx';
import { ChangeEvent } from 'react';

import { Heading, Input, Text, Tooltip } from '~src/components/display';
import { useLocalization } from '~src/hooks';

import { Offer, useCreateOfferState } from '../../state/createOfferState';

import { disabled, offerDetail, offerDetailCheckbox, offerDetailCheckboxWrapper } from './offers.module.css';

type OfferDetailsProps = { offerId: number };

export const OfferDetails = ({ offerId }: OfferDetailsProps) => {
  const translate = useLocalization();
  const { offerList, toggleOfferSelected, toggleOfferInstallation } = useCreateOfferState();

  const offer = offerList.find(({ id }) => id === offerId);

  const handleOfferSelected = (event: ChangeEvent<HTMLInputElement>) => {
    toggleOfferSelected(offerId, event.target.checked);
  };

  const handleOfferInstallation = (event: ChangeEvent<HTMLInputElement>) => {
    toggleOfferInstallation(offerId, event.target.checked);
  };

  const { selected } = offer ?? {};

  return offer ? (
    <div className={offerDetail}>
      <Text>{getProductString(offer, translate.ONLY_OUTDOOR_UNIT)}</Text>

      <div className={offerDetailCheckboxWrapper}>
        <div className={offerDetailCheckbox}>
          <Heading level={4}>{translate.SELECTED}</Heading>

          <Input type='checkbox' checked={selected} onChange={handleOfferSelected} />
        </div>

        <Tooltip title={translate.WITHOUT_INSTALLATION_TOOLTIP}>
          <div className={clsx(offerDetailCheckbox, !selected && disabled)}>
            <Heading level={4}>Uden installation</Heading>

            <Input
              disabled={!selected}
              type='checkbox'
              checked={offer.withoutInstallation}
              onChange={handleOfferInstallation}
            />
          </div>
        </Tooltip>
      </div>
    </div>
  ) : (
    <Text>
      {translate.OFFER} {translate.NOT_FOUND.toLowerCase()}
    </Text>
  );
};

const getProductString = (offer: Offer, onlyOutdoorUnitLabel: string): string => {
  const { heatPumpOutdoorUnit, assortedProducts, heatPumpIndoorUnit, solarPanel } = offer;

  if (assortedProducts) {
    return assortedProducts.map(({ quantity, model, brand }) => `${quantity} x ${brand} ${model}`).join('\n');
  }

  if (heatPumpOutdoorUnit) {
    const indoorUnitLabel = heatPumpIndoorUnit ? `+ ${heatPumpIndoorUnit?.model}` : `(${onlyOutdoorUnitLabel})`;

    return `${offer.heatPumpOutdoorUnit?.model} ${indoorUnitLabel}`;
  }

  return `${solarPanel?.model}`;
};
